import '../../js/vendor/polyfills/polyfill-array-from.js';
import '../../js/vendor/polyfills/polyfill-classlist.js';
import '../../js/vendor/polyfills/polyfill-request-animation-frame.js';

import Component from '../../js/core/component.js';
import Collapse from '../../js/utilities/collapse/u-collapse.js';

/**
 * Steps Class
 */
class Steps extends Component {

	/**
	 * Default settings for this component
	 * @return {object} Default settings
	 */
	_defaultSettings () {
		return {
			debug: false,
			element: null,
			icons: false,
		};
	}

	/**
	 * Initialize component
	 */
	_init () {
		this.element = this.settings.element;
		this.list = this.settings.element.querySelector('.c-steps__list');
		this.items = Array.from(this.list.children).filter(
			item => !item.classList.contains('c-steps__item--no-accordion'));	

		this.items.forEach((item) => {
			item.collapse = new Collapse({
				element: item,
				icons: this.settings.icons,
				expanded: false,
				selectors: {
					header: '> .c-steps__title',
					content: '> .c-steps__content'
				},
				classNames: {
					button: 'c-steps__button'
				},
				prepareCssAnimation: true
			});
		});
	}
}
document.addEventListener('newcontent', (e) => {
	e.target.querySelectorAll('.c-steps').forEach((steps) => {
		steps.steps = new Steps({
			element: steps,
			icons: {
				collapsed: '/gui/images/icons/arrow-down.svg',
				expanded: '/gui/images/icons/arrow-up.svg'
			}
		});
	});
});

export default Steps;


// WEBPACK FOOTER //
// ./components/steps/c-steps.js